<div class="d-flex flex-column align-items-center px-4 py-3 mx-auto card-container">
  <div class="card-media">
    <div class="d-flex canavs-totalsales">
      <div class="d-flex flex-column align-items-center w-100 text-wrapper">
        <p class="font-weight-bolder align-self-start first-header">Payment methods</p>
        <p class="font-weight-bolder second-header">{{ dashboardData?.gross_sales ? (dashboardData?.gross_sales | number) : 0 }} {{ currencySlug | uppercase }}</p>
        <p class="third-header">Total sales</p>
      </div>
      <div class="canavas-commission-container d-flex align-items-center flex-column">
        <div>
          <canvas #paymentMethods></canvas>
        </div>
      </div>
    </div>

    <div class="d-flex align-items-center w-100 commission-legend">
      <div [id]="legendContainerId" class="w-100 align-self-start legend-container">
        <ul>
          <li><span class="legend-bullet"></span> POS: {{ pos ? (pos | number) : 0 }} {{ currencySlug | uppercase }}</li>
          <li><span class="legend-bullet"></span> Cash: {{ cash ? (cash | number) : 0 }} {{ currencySlug | uppercase }}</li>
          <li><span class="legend-bullet"></span> Online Payment: {{ onlinePayment ? (onlinePayment | number) : 0 }} {{ currencySlug | uppercase }}</li>
        </ul>
      </div>
    </div>
  </div>
</div>
